import { memo } from 'react'

import { CS, CS_m } from 'back-end-api'
import useResponsiveHp from 'hooks/useResponsiveHp'
import ExpandBtn from 'components/common/buttons/Expand'
import List from 'components/common/List'
import Element from './Element'

function isVideoCallProductWithPendingOrAcceptedAppointment(registration: CS_m.ModelsRegistration) {
  const summary = CS.getSummary(registration)
  const appointment = CS.getAppointment(summary)
  return (
    (summary?.product === CS_m.ModelsSummaryProduct.videoCall &&
      appointment?.status === CS_m.ModelsAppointmentStatus.pending) ||
    appointment?.status === CS_m.ModelsAppointmentStatus.accepted
  )
}

interface EncountersProps {
  onExpand: () => void
  expanded: boolean
}

const Encounters = ({ onExpand, expanded }: EncountersProps) => {
  const hp = useResponsiveHp()
  const registrations = CS.useRegistrationsList({
    without_old_closed_summaries: 'true',
  }).data
    ?.filter(
      (r: CS_m.ModelsRegistration) =>
        // Show all non-closed summaries (regardless of who, if anyone, has locked it).
        // Video-call summaries with a pending/accepted appointment live in the
        // Appointments tab, so they're excluded here.
        !!CS.getSummary(r) &&
        !isVideoCallProductWithPendingOrAcceptedAppointment(r) &&
        !CS.isSummaryStatusFinal(CS.getSummary(r))
    )
    // Sort chronologically, newest first (matches the date shown on each card)
    .sort(
      (a: CS_m.ModelsRegistration, b: CS_m.ModelsRegistration) =>
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    )

  return (
    <div className="relative w-full h-full">
      <div className="relative flex items-center justify-end px-8 h-16">
        <ExpandBtn expanded={expanded} onExpand={onExpand} canExpand style={undefined} />
      </div>
      <List
        className="px-8 pb-8"
        containerClassName={undefined}
        height={expanded ? hp(72) : hp(35)}
      >
        {registrations?.map((r: CS_m.ModelsRegistration, idx: number) => (
          <Element key={r.id} style={!idx ? { marginTop: 0 } : {}} registration={r} />
        ))}
      </List>
    </div>
  )
}

Encounters.whyDidYouRender = true

export default memo(Encounters)
